import React from 'react';
import { Form, Input, Button } from 'antd';

interface SupplierFormProps {
  form: any;
  initialValues?: any;
  onFinish: (values: any) => void;
  loading?: boolean;
  submitText?: string;
  hideFields?: string[];
}

const SupplierForm: React.FC<SupplierFormProps> = ({
  form,
  initialValues = {},
  onFinish,
  loading = false,
  submitText = 'Lưu',
  hideFields = [],
}) => {
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={onFinish}
    >
      {!hideFields.includes('name') && (
        <Form.Item
          name="name"
          label="Tên nhà cung cấp"
          rules={[{ required: true, message: 'Nhập tên nhà cung cấp!' }]}
        >
          <Input placeholder="Tên nhà cung cấp" size="large" />
        </Form.Item>
      )}
      {!hideFields.includes('tax_code') && (
        <Form.Item name="tax_code" label="Mã số thuế">
          <Input placeholder="Mã số thuế" size="large" />
        </Form.Item>
      )}
      {!hideFields.includes('contact_phone') && (
        <Form.Item name="contact_phone" label="Số điện thoại">
          <Input placeholder="Số điện thoại" size="large" />
        </Form.Item>
      )}
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" size="large" loading={loading} style={{ width: '100%' }}>
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SupplierForm; 